var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{class:{ 'is-invalid' : _vm.errorMessage },attrs:{"type":"text","placeholder":_vm.placeholder},model:{value:(_vm.inputText),callback:function ($$v) {_vm.inputText=$$v},expression:"inputText"}})}
var staticRenderFns = []

export { render, staticRenderFns }